import React, { useState } from "react";
import PropTypes from "prop-types";
// ui
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
// style
import { createStyles, makeStyles, styled } from "@material-ui/styles";
// components
import TemplateSystem from "../components/TemplateSystem";
// utils

//
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
  })
);

//
const GisPage = () => {
  // style
  const classes = useStyles();
  // props

  // local state

  return (
    <TemplateSystem>
      <Grid container justifyContent="center">
        <Grid item>
          <Box pt={5}>
            <Typography variant="h5">GisPage</Typography>
          </Box>
        </Grid>
      </Grid>
    </TemplateSystem>
  );
};

GisPage.propTypes = {};

GisPage.defaultProps = {};

export default GisPage;
